import React, { useEffect } from 'react';
import logo from '../assets/image.png';
import  '../styles/BackgroundAnimation.css';

const BackgroundAnimation = () => {
  useEffect(() => {
    // Firefox size adjustment
    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    
    if (isFirefox) {
      const adjustFirefoxSizes = () => {
        const images = document.querySelectorAll('.panoramic-image');
        images.forEach(img => {
          // Create temp image to get actual dimensions
          const tempImg = new Image();
          tempImg.onload = function() {
            const aspectRatio = this.width / this.height;
            
            if (img.classList.contains('smallest')) {
              img.style.width = '80px';
              img.style.height = Math.round(80 / aspectRatio) + 'px';
            } else if (img.classList.contains('smaller')) {
              img.style.width = '100px';
              img.style.height = Math.round(100 / aspectRatio) + 'px';
            } else {
              img.style.width = '120px';
              img.style.height = Math.round(120 / aspectRatio) + 'px';
            }
          };
          tempImg.src = logo;
        });
      };
      
      // Run on mount and after a delay to ensure DOM is ready
      setTimeout(adjustFirefoxSizes, 100);
      setTimeout(adjustFirefoxSizes, 1000);
    }
  }, []);

  return (
    <div className="background-animation">
      <div className="panoramic-scroll">
        <div className="panoramic-layer layer-1">
          {Array.from({ length: 20 }).map((_, i) => (
            <img key={i} src={logo} alt="" className="panoramic-image" />
          ))}
        </div>
     
      </div>
      <div className="smooth-space"></div>
      <div className="gradient-sphere sphere-1"></div>
      <div className="gradient-sphere sphere-2"></div>
      <div className="gradient-sphere sphere-3"></div>
    </div>
  );
};

export default BackgroundAnimation;
